import { render, staticRenderFns } from "./paychannel.vue?vue&type=template&id=6ce9f8b4&scoped=true"
import script from "./paychannel.vue?vue&type=script&lang=js"
export * from "./paychannel.vue?vue&type=script&lang=js"
import style0 from "./paychannel.vue?vue&type=style&index=0&id=6ce9f8b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce9f8b4",
  null
  
)

export default component.exports